module.exports = __webpack_public_path__ + "static/media/bg.2569fe94.png";